import { isAuthenticated } from '../utils/authHelper';
import React, { Component } from 'react';
import 'react-table/react-table.css';
import {
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  TextField,
  ListItemText,
  Input
} from '@material-ui/core';
import { MenuProps, mandatoryFieldLabelProps } from '../materialUIStyles';
import { createMuiTheme } from '@material-ui/core/styles'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { Dialog, DialogContent, DialogActions, DialogTitle } from '@material-ui/core';
import _ from 'lodash';
import Header from './Header'
import { emailValidation, textEmptyValidation, phoneNumberValidation } from "../utils/Validations";
import { fetchData } from "../utils/fetchData";
import { addUser, deleteUser, restoreUser, updateUser, addAuthForSuperCeF, removeAuthForSuperCeF, fetchRoles } from "../services/hrmsUser/hrmsUser.service";
import ReportTable from './MultiSelectTable/ReportTable';
import LoadingPage from "./LoadingPage";
import token from '../config/jwt_token'
import { browserHistory } from 'react-router'
import { getStatesAndCities } from '../utils/VendorApiUtils'
const errorText = 'This field is required';
// const roles = ["City Finance", "P&L", "Central Finance", "Super Central Finance", "Vendor Approver L2", "Report Viewer", "Root/Backend"];
const userDetails = `/api/v1/user`;
const theme = createMuiTheme({
  overrides: {
    MuiListItemText: {
      secondary: {
        textDecoration: 'line-through',
        color: 'red'
      }
    }
  }
});
class UserListingPage extends Component {
  constructor(props) {
    super(props);
    if (!isAuthenticated()) {
      browserHistory.push('/')
    }
    let columns = [
      {
        Header: 'Employee Code',
        accessor: 'emp_id'
      },
      {
        Header: 'Name',
        accessor: 'name'
      },
      {
        Header: 'Department',
        accessor: 'department',
      },
      {
        Header: 'City',
        accessor: 'city',
        sortable: false
      },
      {
        Header: 'Status',
        accessor: 'statusType',
        sortable: false
      },
      {
        Header: 'Role',
        accessor: 'role',
      },
      {
        Header: 'Work Area',
        accessor: 'entity',
      },
      {
        Header: 'Work Place',
        accessor: 'entity_name',
      },
      {
        Header: 'Actions',
        accessor: 'action',
      }
    ];
    this.state = {
      tableData: [],
      dialogOpen: false,
      isLoading: true,
      data: {
        selectedCity: '',
        selectedCityId: (this.id !== null) ? this.id : '',
        detailsFilter: ''
      },
      isInRequest: false,
      responseDialog: false,
      deleteDialog: false,
      deleteUserId: '',
      restoreDialog: false,
      restoreUserId: '',
      responseDialogIsSuccess: false,
      responseDialogMessage: '',
      cityData: [],
      columns: columns,
      endpoint: userDetails,
      superCeFIds:new Set(),
      dialogConfig: {
        open: false,
        dialogTitle: '',
        dialogContent: '',
        mode: 'INPUT', //could be input , response,
        successResponse: true
      },
      addNewUser: {
        emp_id: '',
        name: '',
        email: '',
        department: '',
        city: [],
        role: '',
        phoneNumber: '',
        entity: '',
        entity_name: ''
      },
      totalPages: 1,
      searchPlaceholder: 'Use Name or Code',
      emp_id_err_status: false,
      emp_id_err: '',
      name_err_status: false,
      name_err: '',
      email_err_status: false,
      email_err: '',
      role_err_status: false,
      role_err: '',
      phoneNumber_err_status: false,
      phoneNumber_err: '',
      city_err_status: false,
      city_err: '',
      roles: [],
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.handleRestoreClick = this.handleRestoreClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleValidate = this.handleValidate.bind(this);
    this.handleUpdateChange = this.handleUpdateChange.bind(this);
    this.handleAddUser = this.handleAddUser.bind(this);
    this.handleUpdateUser = this.handleUpdateUser.bind(this);
    this.handleDeleteUser = this.handleDeleteUser.bind(this);
    this.handleRestoreUser = this.handleRestoreUser.bind(this);
  }

  componentWillMount() {
    this.handleFetchRoles();
  }

  async componentDidMount() {
    if (!token || (token.role !== 'root')) {
      browserHistory.push('/')
      return
    }
    this.setState({isLoading: true});
    getStatesAndCities().then((response) => {
      if (response && response.status === 'success') {
        response.data.unshift({city_id: 'all',city_name: 'All Cities', state_name:''});
        this.setState({cityData: response.data});
      }
    })
    let superCeFIds = await fetchData(this.state.endpoint+'/superIds', 'get', {}, {});
    this.setState({isLoading: false, superCeFIds: new Set(superCeFIds.data.data)})
  }

  handleFetchRoles = async () => {
    try {
      const userRoles = await fetchRoles();
      if(userRoles.status === 200) {
        this.setState({
          roles: userRoles.data.roles
        });
      }
    } catch (error) {
      console.error(error)
    }
  }

  handleClose = () => {
    this.setState({
      isInRequest: false,
      dialogConfig: {
        ...this.state.dialogConfig,
        open: false
      },
      emp_id_err_status: false,
      emp_id_err: '',
      name_err_status: false,
      name_err: '',
      email_err_status: false,
      email_err: '',
      role_err_status: false,
      role_err: '',
      city_err_status: false,
      city_err: ''
    })
  }

  handleDialogClose = () => {
    this.setState({dialogOpen: false});
  }

  handleResponseDialogClose = () => {
    this.setState({responseDialog: false});
  }
  handleDeleteDialogClose = () => {
    this.setState({
      deleteDialog: false,
      deleteUserId: ''
    });
  }
  handleRestoreDialogClose = () => {
    this.setState({
      restoreDialog: false,
      restoreUserId: ''
    });
  }


  handleValidate = (mode) => {
    this.setState({
      emp_id_err_status: false,
      emp_id_err: '',
      name_err_status: false,
      name_err: '',
      email_err_status: false,
      email_err: '',
      role_err_status: false,
      role_err: '',
      city_err_status: false,
      city_err: '',
      phoneNumber_err_status: false,
      phoneNumber_err: '',
    })
    if (mode === 'update') {
      if (textEmptyValidation(this.state.selectedUser.emp_id).status === false) {
        this.setState({
          emp_id_err_status: true,
          emp_id_err: errorText
        })
        return false;
      }
      if (textEmptyValidation(this.state.selectedUser.name).status === false) {
        this.setState({
          name_err_status: true,
          name_err: errorText
        })
        return false;
      }
      if (textEmptyValidation(this.state.selectedUser.city.toString()).status === false) {
        this.setState({
          city_err_status: true,
          city_err: errorText
        })
        return false;
      }
      if (textEmptyValidation(this.state.selectedUser.email).status === false) {
        this.setState({
          email_err_status: true,
          email_err: errorText
        })
        return false;
      } else if (emailValidation(this.state.selectedUser.email).status === false) {
        this.setState({
          email_err_status: true,
          email_err: "Invalid Email"
        })
        return false;
      }
      if (textEmptyValidation(this.state.selectedUser.role).status === false) {
        this.setState({
          role_err_status: true,
          role_err: errorText
        })
        return false;
      }
      if (this.state.selectedUser.role === 'Super Central Finance') {
        if (textEmptyValidation(this.state.selectedUser.phoneNumber).status === false) {
          this.setState({
            phoneNumber_err_status: true,
            phoneNumber_err: errorText
          })
          return false;
        }
        if (phoneNumberValidation(this.state.selectedUser.phoneNumber).status === false) {
          this.setState({
            phoneNumber_err_status: true,
            phoneNumber_err: "Invalid Phone Number"
          })
          return false;
        }
      }
    } else {
      if (textEmptyValidation(this.state.addNewUser.emp_id).status === false) {
        this.setState({
          emp_id_err_status: true,
          emp_id_err: errorText
        })
        return false;
      }
      if (textEmptyValidation(this.state.addNewUser.name).status === false) {
        this.setState({
          name_err_status: true,
          name_err: errorText
        })
        return false;
      }
      if (textEmptyValidation(this.state.addNewUser.city.toString()).status === false) {
        this.setState({
          city_err_status: true,
          city_err: errorText
        })
        return false;
      }
      
      if (textEmptyValidation(this.state.addNewUser.email).status === false) {
        this.setState({
          email_err_status: true,
          email_err: errorText
        })
        return false;
      }
      if (emailValidation(this.state.addNewUser.email).status === false) {
        this.setState({
          email_err_status: true,
          email_err: "Invalid Email"
        })
        return false;
      }
      if (textEmptyValidation(this.state.addNewUser.role).status === false) {
        this.setState({
          role_err_status: true,
          role_err: errorText
        })
        return false;
      }
      if (this.state.addNewUser.role === 'Super Central Finance') {
        if (textEmptyValidation(this.state.addNewUser.phoneNumber).status === false) {
          this.setState({
            phoneNumber_err_status: true,
            phoneNumber_err: errorText
          })
          return false;
        }
        if (phoneNumberValidation(this.state.addNewUser.phoneNumber).status === false) {
          this.setState({
            phoneNumber_err_status: true,
            phoneNumber_err: "Invalid Phone Number"
          })
          return false;
        }
      }
    }
    return true;
  }

  handleEditClick = async (record) => {
    let response;
    if(record.role === 'Super Central Finance'){
      response = await fetchData(this.state.endpoint+'/getPhoneNumber','get', {},{
        user_id: record.id
      });
    }

    this.setState({
      selectedUser: {
        emp_id: record.emp_id,
        name: record.name,
        email: record.email,
        department: record.department,
        city: record.city && record.city.split(','),
        role: record.role,
        entity: record.entity,
        entity_name: record.entity_name,
        phoneNumber: record.role === 'Super Central Finance'?response.data.phoneNumber:''
      },
      prevUserRole: record.role,
      updateUserId: record.id,
      dialogConfig: {
        dialogTitle: 'Update User Data',
        mode: 'UPDATE',
        open: true
      }
    })
  }
  handleDeleteClick = async (record) => {
    this.setState({
      deleteDialog: true,
      deleteUserId: record.id
    })
  }
  handleRestoreClick = async (record) => {
    this.setState({
      restoreDialog: true,
      restoreUserId: record.id
    })
  }

  handleChange = (event, index, value) => {
    switch (event.target.name) {
      case "cityDropdown":
        if(event.target.value.includes("All Cities")) {
          this.setState({
            addNewUser: {
              ...this.state.addNewUser,
              city: ["All Cities"]
            }
          });
        } else {
          this.setState({
            addNewUser: {
              ...this.state.addNewUser,
              city: event.target.value
            }
          });
        }
        break;
      case "emp_id":
        this.setState({
          addNewUser: {
            ...this.state.addNewUser,
            emp_id: event.target.value
          }
        })
        break;
      case "name":
        this.setState({
          addNewUser: {
            ...this.state.addNewUser,
            name: event.target.value
          }
        })
        break;
      case "department":
        this.setState({
          addNewUser: {
            ...this.state.addNewUser,
            department: event.target.value
          }
        })
        break;
      case "email":
        this.setState({
          addNewUser: {
            ...this.state.addNewUser,
            email: event.target.value
          }
        })
        break;
      case "phoneNumber":
        this.setState({
          addNewUser: {
            ...this.state.addNewUser,
            phoneNumber: event.target.value
          }
        })
        break;
      case "entity":
        this.setState({
          addNewUser: {
            ...this.state.addNewUser,
            entity: event.target.value
          }
        })
        break;
      case "entity_name":
        this.setState({
          addNewUser: {
            ...this.state.addNewUser,
            entity_name: event.target.value
          }
        })
        break;
      case "roleDropdown":
        this.setState({
          addNewUser: {
            ...this.state.addNewUser,
            role: event.target.value
          }
        })
        break;
      case 'filterCity':
        this.state.cityData.map(cityObj => {
          if (cityObj.city_name === event.target.value) {
            this.setState({
              data: {
                ...this.state.data,
                selectedCity: cityObj.city_name,
                selectedCityId: cityObj.city_id,
              }
            }, () => {
              this.handleFetchData(this.state.data.oldState);
            });
          }
        })
        break;
      case 'details_filter':
        this.setState({
          data: {
            ...this.state.data,
            detailsFilter: event.target.value
          }
        }, () => {
          this.handleFetchData(this.state.data.oldState);
        });
        break;
      default:
        break;
    }
  }

  handleUpdateChange = (event, index, value) => {
    switch (event.target.name) {
      case "cityDropdown":
        if(event.target.value.includes("All Cities") && event.target.value[event.target.value.length - 1] === "All Cities") {
          this.setState({
            selectedUser: {
              ...this.state.selectedUser,
              city: ["All Cities"]
            }
          });
        } else {
          let values = event.target.value;
          if(values.includes("All Cities")) {
            values = values.filter(city => city !== "All Cities");
          }
          this.setState({
            selectedUser: {
              ...this.state.selectedUser,
              city: values
            }
          });
        }
        break;
      case "emp_id":
        this.setState({
          selectedUser: {
            ...this.state.selectedUser,
            emp_id: event.target.value
          }
        })
        break;
      case "name":
        this.setState({
          selectedUser: {
            ...this.state.selectedUser,
            name: event.target.value
          }
        })
        break;
      case "department":
        this.setState({
          selectedUser: {
            ...this.state.selectedUser,
            department: event.target.value
          }
        })
        break;
      case "email":
        this.setState({
          selectedUser: {
            ...this.state.selectedUser,
            email: event.target.value
          }
        })
        break;
      case "phoneNumber":
          this.setState({
            selectedUser: {
              ...this.state.selectedUser,
              phoneNumber: event.target.value
            }
          })
          break;
      case "entity":
        this.setState({
          selectedUser: {
            ...this.state.selectedUser,
            entity: event.target.value
          }
        })
        break;
      case "entity_name":
        this.setState({
          selectedUser: {
            ...this.state.selectedUser,
            entity_name: event.target.value
          }
        })
        break;
      case "roleDropdown":
        this.setState({
          selectedUser: {
            ...this.state.selectedUser,
            role: event.target.value
          }
        })
        break;
      default:
        break;
    }
  }

  handleUpdateUser = async () => {
    if (this.handleValidate('update')) {
      this.setState({isInRequest: true, responseDialogIsSuccess: true, responseDialogMessage: ''});
      let role = this.state.selectedUser.role
      let body = this.state.selectedUser;
      body.city = body.city.includes("All Cities") ? this.state.cityData.map(city => city.city_name).filter(cityName => cityName !== 'All Cities') : body.city;
      body.role = role === 'Super Central Finance' ? 'Central Finance':this.state.selectedUser.role;
      let response = await updateUser(this.state.updateUserId, body);
      let responseAuth
      //  do it for the first time
      if(role === 'Super Central Finance'){
        responseAuth = await addAuthForSuperCeF({phone_number:body.phoneNumber, user_id:response.data.id})
      }
      let responseDelete;
      if(this.state.prevUserRole === 'Super Central Finance' && this.state.prevUserRole !== role) {
        responseDelete = await removeAuthForSuperCeF({user_id:response.data.id})
      }

      if (response.status === 200) {
        this.setState({
          dialogConfig: {
            ...this.state.dialogConfig,
            open: false
          },
          isInRequest: false,
          responseDialog: true,
          responseDialogMessage: response.data.message,
          selectedUser: {
            emp_id: '',
            name: '',
            email: '',
            department: '',
            city: [],
            role: '',
            phoneNumber: '',
            entity: '',
            entity_name: ''
          }
        });
        this.handleFetchData(this.state.data.oldState);
        window.location.reload();
      } else {
        this.setState({
          isInRequest: false,
          responseDialogIsSuccess: false,
          responseDialog: true,
          responseDialogMessage: (response.data.message !== undefined) ? response.data.message : "O..oh something went wrong!"
        })
      }
    }
  };

  cleanText = (text) => {
    return text === null || text === undefined ? '' : text;
  }

  handleAddUser = async () => {
    if (this.handleValidate('add')) {
      this.setState({isInRequest: true, responseDialogMessage: '', responseDialogIsSuccess: true});
      let role = this.state.addNewUser.role
      let body = this.state.addNewUser;
      body.role = role === 'Super Central Finance' ? 'Central Finance':this.state.addNewUser.role;
      body.city = body.city.includes("All Cities") ? this.state.cityData.map(city => city.city_name).filter(cityName => cityName !== 'All Cities') : body.city;
      let response = await addUser(body)
      if(role === 'Super Central Finance'){
        response = await addAuthForSuperCeF({phone_number:body.phoneNumber, user_id:response.data.id})
      }
      if (response.status === 201) {
        this.setState({
          dialogConfig: {
            ...this.state.dialogConfig,
            open: false
          },
          isInRequest: false, responseDialog: true, responseDialogMessage: response.data.message,
          addNewUser: {
            emp_id: '',
            name: '',
            email: '',
            department: '',
            city: [],
            role: '',
            phoneNumber: '',
            entity: '',
            entity_name: ''
          }
        });
        this.setState({isInRequest: false, responseDialog: true, responseDialogMessage: response.data.message})
      } else {
        this.setState({
          isInRequest: false,
          responseDialogIsSuccess: false,
          responseDialog: true,
          responseDialogMessage: (response.data.message !== undefined) ? response.data.message : "O..oh something went wrong!"
        })
      }
    }
  }
  handleDeleteUser = async () => {
    this.setState({isInRequest: true, responseDialogMessage: '', responseDialogIsSuccess: true});
    let id = this.state.deleteUserId;
    let response = await deleteUser(id);
    if (response.status === 200) {
      this.setState({
        deleteDialog: false,
        deleteUserId: '',
        isInRequest: false, responseDialog: true, responseDialogMessage: response.data.message
      })
    } else {
      this.setState({
        isInRequest: false,
        responseDialogIsSuccess: false,
        responseDialog: true,
        responseDialogMessage: (response.data.message !== undefined) ? response.data.message : "O..oh something went wrong!"
      })
    }
  }

  handleRestoreUser = async () => {
    this.setState({isInRequest: true, responseDialogMessage: '', responseDialogIsSuccess: true});
    let id = this.state.restoreUserId;
    let response = await restoreUser(id);
    if (response.status === 200) {
      this.setState({
        restoreDialog: false,
        restoreUserId: '',
        isInRequest: false, responseDialog: true, responseDialogMessage: response.data.message
      })
    } else {
      this.setState({
        isInRequest: false,
        responseDialogIsSuccess: false,
        responseDialog: true,
        responseDialogMessage: (response.data.message !== undefined) ? response.data.message : "O..oh something went wrong!"
      })
    }
  }

  handleSortOptions = (sorted) => {
    let sortedParam = {};
    if (sorted.length > 0) {
      sortedParam = sorted[0];
      sortedParam = {
        sort_by: sortedParam.id,
        sort_order: (sortedParam.desc) ? 'desc' : 'asc'
      }
    }
    if (sortedParam.sort_by === 'employee_code')
      return {};
    return sortedParam;
  };

  handleFetchData = async (state) => {
    this.setState({
      data: {
        ...this.state.data,
        oldState: state
      }
    });
    let response = await fetchData(this.state.endpoint, 'get', {}, {
      offset: (state.page) * state.pageSize,
      limit: state.pageSize,
      keyword: this.state.data.detailsFilter,
      city: this.state.data.selectedCity==='All Cities'?'':this.state.data.selectedCity,
      ...this.handleSortOptions(state.sorted)
    });
    if (response.data.data !== undefined) {
      response.data.data.rows = _.reduce(response.data.data.rows, (result, item) => {
        item.action = <div style={{display: 'flex'}}>
          {
            item.status === 1 ?
              <div>
              <Button
                key={item.employee_id}
                variant="contained"
                color='primary'
                onClick={() => {
                  this.handleEditClick(item)
                }
                }
                style={{gridColumnStart: 2}}
              >Edit</Button>
              <Button
                key={item.employee_id}
                variant="contained"
                color='secondary'
                onClick={() => {
                  this.handleDeleteClick(item)
                }
                }
                style={{gridColumnStart: 2, marginLeft: 8}}
              >Delete</Button>
              </div>
              :
              <Button
                key={item.employee_id}
                variant="contained"
                onClick={() => {
                  this.handleRestoreClick(item)
                }
                }
                style={{gridColumnStart: 2, marginLeft: 8}}
              >Restore</Button>
          }
        </div>;
        let cityName = "";
        this.state.cityData.map((city, index) => {
          if (item.city === city.city_name)
            cityName = city.city_name;
        });
        item.cityName = cityName;
        item.statusType = item.status?'Active':'Inactive';
        //item.isSuperCef = this.state.superCeFIds.has(item.id) ? 'true':'false';
        item.role = this.state.superCeFIds.has(item.id)?'Super Central Finance':item.role;
        result.push(item);
        return result;
      }, []);
      this.setState({tableData: response.data.data.rows, totalPages: response.data.data.pages})
    }

  }

  handleUserChange = () => {
    this.handleResponseDialogClose()
    this.handleFetchData(this.state.data.oldState);
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <Header />
        <div className="zaps-page-wrap">
          {!this.state.isLoading ?
            <div>
              {/* Page header */}
              <div className="zaps-page-header">
                <div>
                  <h2 className="zaps-page-title">User Management</h2>
                  <p className="zaps-page-subtitle">Manage system users, roles and city access</p>
                </div>
                <Button variant="contained" size="medium" color="primary"
                  onClick={() => this.setState({
                    dialogConfig: {
                      ...this.state.dialogConfig,
                      open: true,
                      mode: 'INPUT',
                      dialogTitle: 'New User Data'
                    }
                  })}>
                  Add New User
                </Button>
              </div>

              {/* Filter row */}
              <div className="zaps-filter-row" style={{ marginBottom: 20 }}>
                <FormControl style={{ minWidth: 160 }}>
                  <InputLabel shrink={true}>City</InputLabel>
                  <Select
                    value={this.state.data.selectedCity}
                    name="filterCity"
                    onChange={this.handleChange}
                  >
                    {
                      this.state.cityData.map((city, index) => (
                        <MenuItem key={index} value={city.city_name}>
                          <ListItemText primary={city.city_name} />
                        </MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
                <TextField
                  fullWidth={false}
                  label="Filter"
                  placeholder="Name, Employee Code"
                  name='details_filter'
                  onChange={this.handleChange}
                  value={this.state.data.detailsFilter}
                  style={{ minWidth: 220 }}
                />
              </div>

              <ReportTable className="reactTable" data={this.state.tableData} columns={this.state.columns}
                           pages={this.state.totalPages} handleFetchData={this.handleFetchData}
              />
          </div> : <LoadingPage/>}
          <Dialog
            open={this.state.dialogConfig.open}
            onClose={this.handleClose}
          >
            <DialogTitle>
              {this.state.dialogConfig.dialogTitle}
            </DialogTitle>
            <DialogContent>
              {
                this.state.dialogConfig.mode === 'INPUT' &&
                <Grid
                  container
                  alignItems='center'
                >

                  <Grid item xs={12}>
                    <TextField
                      className="dialogInputFileds"
                      style={{minWidth: '100px', marginBottom: '15px'}}
                      label={<div><span style={mandatoryFieldLabelProps}>*</span>Employee Code
                      </div>}
                      InputLabelProps={{
                        shrink: true
                      }}
                      value={this.state.addNewUser.emp_id}
                      error={this.state.emp_id_err_status}
                      helperText={this.state.emp_id_err}
                      name="emp_id"
                      onChange={this.handleChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      className="dialogInputFileds"
                      style={{minWidth: '100px', marginBottom: '15px'}}
                      label={<div><span style={mandatoryFieldLabelProps}>*</span>Name</div>}
                      InputLabelProps={{
                        shrink: true
                      }}
                      value={this.state.addNewUser.name}
                      error={this.state.name_err_status}
                      helperText={this.state.name_err}
                      name="name"
                      onChange={this.handleChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      className="dialogInputFileds"
                      style={{minWidth: '100px', marginBottom: '15px'}}
                      label={<div><span style={mandatoryFieldLabelProps}>*</span>Email</div>}
                      InputLabelProps={{
                        shrink: true
                      }}
                      value={this.state.addNewUser.email}
                      error={this.state.email_err_status}
                      helperText={this.state.email_err}
                      name="email"
                      onChange={this.handleChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      className="dialogInputFileds"
                      style={{minWidth: '100px', marginBottom: '15px'}}
                      label={<div>Department</div>}
                      InputLabelProps={{
                        shrink: true
                      }}
                      value={this.cleanText(this.state.addNewUser.department)}
                      name="department"
                      onChange={this.handleChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl className="dialogInputFileds"
                                 style={{minWidth: '100px', marginBottom: '15px'}}>
                      <InputLabel>{<div><span
                        style={mandatoryFieldLabelProps}>*</span><span>City</span>
                      </div>}</InputLabel>
                      <Select
                        value={this.state.addNewUser.city}
                        onChange={this.handleChange}
                        input={<Input id="select-multiple-chip"/>}
                        name="cityDropdown"
                        MenuProps={MenuProps}
                        multiple
                      >
                        {
                          this.state.cityData.map((city, index) => {
                            if (city.city_id !== '')
                              return (
                                <MenuItem 
                                  key={city.city_id + city.city_name}
                                  value={city.city_name}
                                  style={{
                                    fontWeight:
                                      this.state.cityData[index].city_name === city.city_name
                                        ? theme.typography.fontWeightRegular
                                        : theme.typography.fontWeightMedium,
                                  }}
                                >
                                  {city.city_name}
                                </MenuItem>
                              )
                          })
                        }
                      </Select>
                      <span style={{
                        fontSize: '0.75rem',
                        color: '#f44336'
                      }}>{this.state.city_err}</span>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl className="dialogInputFileds"
                                 style={{minWidth: '100px', marginBottom: '15px'}}>
                      <InputLabel>{<div><span
                        style={mandatoryFieldLabelProps}>*</span><span>Role</span>
                      </div>}</InputLabel>
                      <Select
                        value={this.state.addNewUser.role}
                        onChange={this.handleChange}
                        name="roleDropdown"
                      >
                        {
                          this.state.roles.map((role, index) => {
                            return <MenuItem key={index} value={role.role_name}>{role.role_label}</MenuItem>
                          })
                        }
                      </Select>
                      <span style={{
                        fontSize: '0.75rem',
                        color: '#f44336'
                      }}>{this.state.role_err}</span>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    {this.state.addNewUser.role === 'Super Central Finance'?
                      <TextField
                        className="dialogInputFileds"
                        style={{minWidth: '100px', marginBottom: '15px'}}
                        label={<div><span style={mandatoryFieldLabelProps}>*</span>Phone Number</div>}
                        InputLabelProps={{
                          shrink: true
                        }}
                        value={this.state.addNewUser.phoneNumber}
                        error={this.state.phoneNumber_err_status}
                        helperText={this.state.phoneNumber_err}
                        name="phoneNumber"
                        onChange={this.handleChange}
                      />:<div/>
                    }
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      className="dialogInputFileds"
                      style={{minWidth: '100px', marginBottom: '15px'}}
                      label={<div>Work Area</div>}
                      InputLabelProps={{
                        shrink: true
                      }}
                      value={this.cleanText(this.state.addNewUser.entity)}
                      name="entity"
                      onChange={this.handleChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      className="dialogInputFileds"
                      style={{minWidth: '100px', marginBottom: '15px'}}
                      label={<div>Work Place</div>}
                      InputLabelProps={{
                        shrink: true
                      }}
                      value={this.cleanText(this.state.addNewUser.entity_name)}
                      name="entity_name"
                      onChange={this.handleChange}
                    />
                  </Grid>
                </Grid>
              }
              {
                this.state.dialogConfig.mode === 'UPDATE' &&
                <Grid
                  container
                  alignItems='center'
                >

                  <Grid item xs={12}>
                    <TextField
                      className="dialogInputFileds"
                      style={{minWidth: '100px', marginBottom: '15px'}}
                      label={<div><span style={mandatoryFieldLabelProps}>*</span>Employee Code
                      </div>}
                      InputLabelProps={{
                        shrink: true
                      }}
                      value={this.state.selectedUser.emp_id}
                      error={this.state.emp_id_err_status}
                      helperText={this.state.emp_id_err}
                      name="emp_id"
                      onChange={this.handleUpdateChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      className="dialogInputFileds"
                      style={{minWidth: '100px', marginBottom: '15px'}}
                      label={<div><span style={mandatoryFieldLabelProps}>*</span>Name</div>}
                      InputLabelProps={{
                        shrink: true
                      }}
                      error={this.state.name_err_status}
                      helperText={this.state.name_err}
                      value={this.state.selectedUser.name}
                      name="name"
                      onChange={this.handleUpdateChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      className="dialogInputFileds"
                      style={{minWidth: '100px', marginBottom: '15px'}}
                      label={<div><span style={mandatoryFieldLabelProps}>*</span>Email</div>}
                      InputLabelProps={{
                        shrink: true
                      }}
                      value={this.state.selectedUser.email}
                      error={this.state.email_err_status}
                      helperText={this.state.email_err}
                      name="email"
                      onChange={this.handleUpdateChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      className="dialogInputFileds"
                      style={{minWidth: '100px', marginBottom: '15px'}}
                      label={<div>Department</div>}
                      InputLabelProps={{
                        shrink: true
                      }}
                      value={this.cleanText(this.state.selectedUser.department)}
                      name="department"
                      onChange={this.handleUpdateChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl className="dialogInputFileds"
                                 style={{minWidth: '100px', marginBottom: '15px'}}>
                      <InputLabel>{<div><span
                        style={mandatoryFieldLabelProps}>*</span><span>City</span>
                      </div>}</InputLabel>
                      <Select
                        value={this.state.selectedUser.city}
                        onChange={this.handleUpdateChange}
                        input={<Input id="select-multiple-chip"/>}
                        name="cityDropdown"
                        MenuProps={MenuProps}
                        style={{
                          maxWidth: '530px'
                        }}
                        multiple
                      >
                        {
                          this.state.cityData.map((city, index) => {
                            if (city.city_id !== '')
                              return <MenuItem key={city.city_id + city.city_name}
                                               value={city.city_name}>{city.city_name}</MenuItem>
                          })
                        }
                      </Select>
                      <span style={{
                        fontSize: '0.75rem',
                        color: '#f44336'
                      }}>{this.state.city_err}</span>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl className="dialogInputFileds"
                                 style={{minWidth: '100px', marginBottom: '15px'}}>
                      <InputLabel>{<div><span
                        style={mandatoryFieldLabelProps}>*</span><span>Role</span>
                      </div>}</InputLabel>
                      <Select
                        value={this.cleanText(this.state.selectedUser.role)}
                        onChange={this.handleUpdateChange}
                        name="roleDropdown"
                      >
                        {
                          this.state.roles.map((role, index) => {
                            return <MenuItem key={index} value={role.role_name}>{role.role_label}</MenuItem>
                          })
                        }
                      </Select>
                      <span style={{
                        fontSize: '0.75rem',
                        color: '#f44336'
                      }}>{this.state.role_err}</span>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    {this.state.selectedUser.role === 'Super Central Finance'?
                      <TextField
                        className="dialogInputFileds"
                        style={{minWidth: '100px', marginBottom: '15px'}}
                        label={<div><span style={mandatoryFieldLabelProps}>*</span>Phone Number</div>}
                        InputLabelProps={{
                          shrink: true
                        }}
                        value={this.state.selectedUser.phoneNumber}
                        error={this.state.phoneNumber_err_status}
                        helperText={this.state.phoneNumber_err}
                        name="phoneNumber"
                        onChange={this.handleUpdateChange}
                      />:<div/>
                    }
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      className="dialogInputFileds"
                      style={{minWidth: '100px', marginBottom: '15px'}}
                      label={<div>Work Area</div>}
                      InputLabelProps={{
                        shrink: true
                      }}
                      value={this.cleanText(this.state.selectedUser.entity)}
                      name="entity"
                      onChange={this.handleUpdateChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      className="dialogInputFileds"
                      style={{minWidth: '100px', marginBottom: '15px'}}
                      label={<div>Work Place</div>}
                      InputLabelProps={{
                        shrink: true
                      }}
                      value={this.cleanText(this.state.selectedUser.entity_name)}
                      name="entity_name"
                      onChange={this.handleUpdateChange}
                    />
                  </Grid>
                </Grid>
              }
            </DialogContent>
            <DialogActions>
              {
                this.state.dialogConfig.mode === "INPUT" &&
                <div>
                  <Button variant="contained" color="secondary"
                          onClick={this.handleClose}>Cancel</Button>
                  <Button variant="contained" color="primary" onClick={this.handleAddUser}
                          disabled={this.state.isInRequest} style={{marginLeft: '20px'}}>Add</Button>
                </div>
              }
              {
                this.state.dialogConfig.mode === "UPDATE" &&
                <div>
                  <Button variant="contained" color="secondary"
                          onClick={this.handleClose}>Cancel</Button>
                  <Button variant="contained" color="primary" onClick={this.handleUpdateUser}
                          disabled={this.state.isInRequest}
                          style={{marginLeft: '20px'}}>Update</Button>
                </div>
              }
            </DialogActions>
          </Dialog>
          <Dialog
            open={this.state.responseDialog}
            onClose={this.handleResponseDialogClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle>
              {(this.state.responseDialogIsSuccess) ? <span className="success">Response</span> :
                <span className="error">Error</span>}
            </DialogTitle>
            <DialogContent>
              {this.state.responseDialogMessage}
            </DialogContent>
            <DialogActions>
              {(this.state.responseDialogIsSuccess) ?
                <Button onClick={this.handleUserChange} color="primary">
                  Okay
                </Button> :
                <Button onClick={this.handleResponseDialogClose} color="primary">
                  Cancel
                </Button>}
            </DialogActions>
          </Dialog>
          <Dialog
            open={this.state.deleteDialog}
            onClose={this.handleDeleteDialogClose}
          >
            <DialogContent>
              Are you sure you want to delete this user
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleDeleteUser} color="primary">
                Yes
              </Button>
              <Button onClick={this.handleDeleteDialogClose} color="primary">
                No
              </Button>}
            </DialogActions>
          </Dialog>
          <Dialog
            open={this.state.restoreDialog}
            onClose={this.handleRestoreDialogClose}
          >
            <DialogContent>
              Are you sure you want to restore this user
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleRestoreUser} color="primary">
                Yes
              </Button>
              <Button onClick={this.handleRestoreDialogClose} color="primary">
                No
              </Button>}
            </DialogActions>
          </Dialog>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default UserListingPage;


// WEBPACK FOOTER //
// ./src/components/UserListingPage.js